module.exports = __webpack_public_path__ + "static/bruno-216d9bece5c3ba285bbbe992c33d213f.png";